import request from '@utils/fetch'

// 查询教材接口
export function selectTeatherShowMaterial(data) {
  return request({
    url: '/showManage/selectTeatherShowMaterial',
    method: 'post',
    data
  })
}

// 根据教材id查素材
export function selectShowThemeData(data) {
  return request({
    url: '/showManage/selectShowThemeData',
    method: 'post',
    data
  })
}

// 根据素材id查详情
export function selectShowTypeData(data) {
  return request({
    url: '/showManage/selectShowTypeData',
    method: 'post',
    data
  })
}

// 根据token 获取用户信息
export function selectTeatherAndphone(data) {
  return request({
    url: '/showManage/selectTeatherAndphone',
    method: 'post',
    data
  })
}
